import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleSetSelectedItems,
  handleSetSelectedFilterIds,
  handleSetSelectedFilterValue,
  handleToggleCollapsed,
  handleSetSelectedSentimentValues,
  handleSetSelectedCategories,
  handleChangeSortBy,
} from 'store/helpers/filterHelpers';
import { handleApplySettingsFilters } from './contentHelpers';
import { linkedinFiltersInitialState } from './initialState/linkedinInitialState';

export { linkedinFiltersInitialState as filtersInitialState };
export const linkedinContentInitialState = {
  filters: linkedinFiltersInitialState,
  sortBy: {
    selected: 'time',
    order: 'desc',
  },
  selectedFilter: 'sentimentFilter',
};
export const linkedinContentSlice = createSlice({
  name: 'linkedinContentSlice',
  initialState: linkedinContentInitialState,
  reducers: {
    setSelectedFilterIds: (state, action) => {
      handleSetSelectedFilterIds(state, action);
    },
    setSelectedItems: (state, action) => {
      handleSetSelectedItems(state, action);
    },
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(state, action, linkedinFiltersInitialState);
    },
    setSelectedSentimentValues: (state, action) => {
      handleSetSelectedSentimentValues(state, action);
    },
    setSelectedCategories: (state, action) => {
      handleSetSelectedCategories(state, action);
    },
    changeSortBy: (state, action) => {
      handleChangeSortBy(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = linkedinFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, linkedinFiltersInitialState);
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const {
  setSelectedFilterIds,
  setSelectedItems,
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  setSelectedFilterValue,
  setSelectedCategories,
  setSelectedSentimentValues,
  changeSortBy,
  applyWebsiteSettingsFilters,
  setSelectedFilter,
} = linkedinContentSlice.actions;
